export default __webpack_public_path__ + "static/media/pitchnet1.82b02df2.mp4";